import useNearbyFilterContext from "@contexts/nearbyFilterContext"
import { colors, size, fontSize } from "@styles/theme"
import styled from "@emotion/styled"

import { HostingAvailabilityFilterSection } from './HostingAvailabilityFilterSection'
import { FullLengthSwitch } from '@elements/form_elements/FullLengthSwitch'
import { LookingStatusFilterSection } from './LookingStatusFilterSection'
import { NearbyFilterRightNowAlert } from './NearbyFilterRightNowAlert'
import { ActionButton } from '@components/auth/landing/LandingElements'
import BackTopbar, { TopbarClearfix } from "@elements/BackTopbar"
import { PositionFilterSection } from './PositionFilterSection'
import { EndowmentSizeSection } from './EndowmentSizeSection'
import { Switch } from '@elements/form_elements/Switch'
import ModalContainer from "@elements/ModalContainer"
import { PiSpinnerBold } from 'react-icons/pi'
import { TbBroadcast } from "react-icons/tb"
import { AgeSection } from './AgeSection'

const Form = styled.form`
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: ${size(2)};
  padding-top: ${size(1)};
  padding-bottom: ${size(20)};

  height: 100%;
  width: 100vw;
  overflow-y: scroll;
  overflow-x: hidden;
`

const SubmitArea = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2;

  display: flex;
  width: 100%;
  background-color: black;
`

const ActiveLabel = styled.label`
  display: flex;
  align-items: center;
  font-size: ${fontSize('sm')};
  font-weight: 500;
`

const Topbar = ({ toggleActive, value, isInactive }) => {
  return (
    <BackTopbar
      title='Filter Profiles'
      titleProps={{ style: { fontSize: fontSize('lg') } }}>
      <ActiveLabel>
        {value ? 'On' : 'Off'}
        <Switch
          isInactive={isInactive}
          onChange={toggleActive}
          checked={value}
        />
      </ActiveLabel>
    </BackTopbar>
  )
}

const NearbyFilterDialog = ({ isOpen, setClosed }) => {
  const {
    toggleActive,
    onToggleButtonClick,
    handleRadioChange,
    handleSliderChange,
    resetAge,
    resetEndowmentSize,
    handleNearbyFilterSubmit,
    filterState,
    isFilterChanged,
    isFilterLoading,
    isFilterLoadingDelayed,
  } = useNearbyFilterContext()

  return(
    <ModalContainer
      renderCustomHeader={() => 
        <Topbar
          value={filterState?.isActive}
          toggleActive={toggleActive}
          isInactive={isFilterLoadingDelayed}
        />
      }
      open={isOpen}
      setClosed={setClosed}>
      <TopbarClearfix style={{ height: size(7) }} />
      <Form
        onSubmit={handleNearbyFilterSubmit}>
        {/* <FullLengthSwitch
          isInactive={isFilterLoadingDelayed}
          name='isOnline'
          checked={filterState?.isOnline}
          labelIcon={() => <TbBroadcast style={{ color: filterState?.isOnline ? colors.statusColors['right_now']('light') : 'grey' }} size={size(3)} />}
          label='Online Now'
          onChange={handleRadioChange}
        /> */}
        <br />
        <LookingStatusFilterSection
          isInactive={isFilterLoadingDelayed}
          value={filterState?.tempStatus}
          onChange={onToggleButtonClick}
        />
        <NearbyFilterRightNowAlert />
        <HostingAvailabilityFilterSection
          isInactive={isFilterLoadingDelayed}
          value={filterState?.hostLocation}
          onChange={onToggleButtonClick}
        />
        <PositionFilterSection
          isInactive={isFilterLoadingDelayed}
          value={filterState?.position}
          onChange={onToggleButtonClick}
        />
        <AgeSection
          isDisplayedInactive={isFilterLoadingDelayed}
          value={filterState?.age}
          onChange={handleSliderChange}
          resetValue={resetAge}
        />
        <EndowmentSizeSection
          isDisplayedInactive={isFilterLoadingDelayed}
          value={filterState?.endowmentSize}
          onChange={handleSliderChange}
          resetValue={resetEndowmentSize}
        />
        {isFilterChanged &&
          <SubmitArea>
            <ActionButton
              disabled={isFilterLoading}
              style={{ background: colors.statusColors.right_now('primary'), filter: isFilterLoadingDelayed && 'grayscale(100%)' }}
              size='large'
              type='submit'>
              {isFilterLoadingDelayed &&
                <PiSpinnerBold
                  size={size(2.5)}
                  className='animation_rotation'
                />
              }
              &nbsp;
              Apply Filters
            </ActionButton>
          </SubmitArea>
        }
      </Form>
    </ModalContainer>
  )
}

export default NearbyFilterDialog
